import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { getSearchSelectedPassenger } from "../../../Lib/Utils/passenger";
import { trainOfferEvtTree } from "../../../Orchestrator/ConstantTree";
import { getRecoilStateValue, getRecoilStateValueWithType, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { OffersRequest, SearchStateType } from "../../../Orchestrator/Types/Index";
import dayjs from 'dayjs'
import { IPassBooking } from "../../../Orchestrator/Types/Types/BookingTypes";

class ApplyPassOfferForSinglePassengerAction extends BaseAction<void, { passBooking: IPassBooking }> {
  override async run(): Promise<void> {

    const { passBooking } = this.params!;
    try {

      if (passBooking) {
        const currentTrainType = getRecoilStateValue<TrainTypeEnum>("trainTypeAtom");
        const searchState = getRecoilStateValue<SearchStateType>("searchStateAtom")
        const { totalWithoutInfants } = getSearchSelectedPassenger(searchState?.passengers);
        
        if (totalWithoutInfants > 1) {
          console.warn("Unable to handle multiple passengers.");
        } else if (totalWithoutInfants === 1) {

          const offerRequest = getRecoilStateValue<OffersRequest>("offersRequestAtom");
          const appliedPassengerPassAtom = getRecoilStateValueWithType("appliedPassengerPassAtom");


          const currentTripPassOffers = currentTrainType === TrainTypeEnum.inbound ? appliedPassengerPassAtom?.inbound || [] : appliedPassengerPassAtom?.outbound || [];

          const isPassAlreadyApplied = currentTripPassOffers.find(pass => pass.passOffer.travelAccount.travelAccount.number === passBooking.travelAccount.travelAccount.number);
          if (isPassAlreadyApplied) {
            updateRecoilState("appliedPassengerPassAtom", {
              [currentTrainType as string]: []
            })
          } else {
            updateRecoilState("appliedPassengerPassAtom", {
              [currentTrainType as string]: [{
                externalRef: offerRequest?.anonymousPassengerSpecifications?.[0].externalRef || "",
                passOffer: passBooking
              }]
            })
          }

          const data = currentTrainType === TrainTypeEnum.inbound ? searchState?.inboundDate : searchState?.outboundDate;
          _eventBus.emit({
            eventName: trainOfferEvtTree.Offer.DateSelector.Change,
            data: {
              fullDate: dayjs(data).toISOString(),
              currentTrainType: currentTrainType,
              search: searchState,
            },
          });
        }

        // Reset selected train and related states
        if (currentTrainType === TrainTypeEnum.outbound) {
          updateRecoilState("selectedOutboundTrainAtom", null);
          updateRecoilState("originalTrainClassSelectionAtom", null);
        } else {
          updateRecoilState("selectedInboundTrainAtom", null);
          updateRecoilState("originalTrainClassSelectionAtom", null);
        }
        updateRecoilState("selectedOfferIdAtom", null);
        updateRecoilState("ticketTypeStateAtom", null);
      }
    } catch (error) {
      console.log("log error", error)
    }
  }
};

export const applyPassOfferForSinglePassengerAction = new ApplyPassOfferForSinglePassengerAction();
